{
  "close": "Schließen",
  "notifications": "{count, plural, one {# Benachrichtigung} other {# Benachrichtigungen}}."
}
